__turbopack_context__.v({
  "logo-container": "AcfLogoFarm-module-scss-module__ptEtsa__logo-container",
  "logo-farm": "AcfLogoFarm-module-scss-module__ptEtsa__logo-farm",
  "logo-farm-container": "AcfLogoFarm-module-scss-module__ptEtsa__logo-farm-container",
});
